import { render } from "./ClientProjects.vue?vue&type=template&id=724b92c2&ts=true"
import script from "./ClientProjects.vue?vue&type=script&lang=ts"
export * from "./ClientProjects.vue?vue&type=script&lang=ts"

import "./ClientProjects.vue?vue&type=style&index=0&id=724b92c2&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__